<template>

  <div class="accordion mypage_menu" v-if="viewFlag == 'my'">
    <!--マイページメニュー SP-->
    <details v-bind:open="isOpen">
      <summary class="Label accordion_title">マイページメニュー</summary>
      <div class="content">
        <ul class="accordion_list">
          <li><a href="/mypage" class="accordion_list_item">マイページTOP</a></li>
          <li v-if="$globalVar.in_app_payments"><a href="/mypage/yagiprime" class="accordion_list_item">ヤギプライム</a></li>
          <li><a href="/mypage/yagioffer" class="accordion_list_item">ヤギオファー</a></li>
          <li v-if="$globalVar.in_app_payments"><a href="/mypage/yagiorder" class="accordion_list_item">お支払い済みサービス</a>
          </li>
          <li><a href="/mypage/account" class="accordion_list_item">アカウント情報</a></li>
          <li v-if="$globalVar.in_app_payments"><a href="/mypage/introduction" class="accordion_list_item">推薦・紹介サービス</a>
          </li>
          <li><a href="#" @click="logout(); $event.preventDefault()"
              class="accordion_list_item accordion_list_itemlast">ログアウト</a></li>
        </ul>
      </div>
    </details>
  </div>
  <div class="accordion service_list" v-else>
    <!--おすすめのメニューSP-->
    <details v-bind:open="isOpen">
      <summary class="Label accordion_title">おすすめのサービス</summary>
      <div class="content">
        <ul class="accordion_list">
          <li><a href="/mypage" class="accordion_list_item">マイページTOP</a></li>
          <li v-if="$globalVar.in_app_payments"><a href="/ai/interview_practice"
              class="accordion_list_item">AI面接練習(β版)</a></li>
          <li v-if="$globalVar.in_app_payments"><a href="/quickemailhelp" class="accordion_list_item"
              target="_blank">ヤギのメール便（企業に送信）</a></li>
          <li v-if="false"><a href="/quickmailhelp" class="accordion_list_item" target="_blank">ヤギの宅配便（企業に郵送代行）</a></li>
          <li><a href="https://www.yagioffer.com/" class="accordion_list_item" target="_blank">ヤギオファー（マッチングサービス）</a>
          </li>
          <li v-if="$globalVar.in_app_payments"><a href="/fontservicehelp" class="accordion_list_item"
              target="_blank">フォント切り替えサービス</a></li>
          <li><a href="https://www.yagish.jp/business/yagibot/" class="accordion_list_item"
              target="_blank">yagibot（LINEで履歴書作成）</a></li>
          <li><a href="https://www.yagish.jp/business/yagitime/" class="accordion_list_item accordion_list_itemlast"
              target="_blank">大学生スケジュールアプリ</a></li>
        </ul>
      </div>
    </details>

  </div>
</template>

<script>
export default {
  props: {
    viewFlag: {
      type: String
    }
  },
  components: {
  },
  data: function () {
    const app = this
    return {
      isWeekEndFlag: true,
      isOpen: true
    }

  },
  created: function () {
    if (this.$deviceLib.isMobileDevice) {
      this.isOpen = false
    } else {
      if (this.$site.appFlag == 'b') {
        this.isOpen = false
      }

    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    alertMaint: function () {
      this.$message({
        message: '以下の日時においてヤギの宅配便サービスの休止を行います。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
        type: 'error'
      })
    },
    logout: async function () {
      console.error('logout')
      this.$firebase.signOut()
      this.$router.push('/login')

    }
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  destroyed: function () {
  }
}
</script>
